import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";

const Header = ({ t }: any) => {
  const [visible, setVisibility] = useState(false);

  const showDrawer = () => {
    setVisibility(!visible);
  };

  const onClose = () => {
    setVisibility(false);
  };

  const scrollTo = (id: string) => {
    const element = document.getElementById(id) as HTMLDivElement;
    if (element) {
      const yOffset = -150; // Adjust as needed
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    setVisibility(false);
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage" onClick={() => scrollTo("intro")}>
            <SvgIcon src="/img/svg/logo.svg" width="200px" height="120px"/>
          </LogoContainer>
          <NotHidden>
            <CustomNavLinkSmall onClick={() => scrollTo("aboutMe")}>
              <Span>{t("About me")}</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => scrollTo("imobiliario")}>
              <Span>{t("Areas of expertise")}</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall
              style={{ width: "180px" }}
              onClick={() => window.open("https://wa.me/5565996285987?text=Olá,%20vim%20pelo%20site.", "_blank")}
            >
              <Span>
                <Button>{t("Contact")}</Button>
              </Span>
            </CustomNavLinkSmall>
          </NotHidden>
          <Burger onClick={showDrawer}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} visible={visible} onClose={onClose}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={onClose}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <CustomNavLinkSmall onClick={() => scrollTo("aboutMe")}>
            <Span>{t("About me")}</Span>
          </CustomNavLinkSmall>
          <CustomNavLinkSmall onClick={() => scrollTo("imobiliario")}>
            <Span>{t("Areas of expertise")}</Span>
          </CustomNavLinkSmall>
          <CustomNavLinkSmall
            style={{ width: "180px" }}
            onClick={() => window.open("https://wa.me/5565996285987?text=Olá,%20vim%20pelo%20site.", "_blank")}
          >
            <Span>
              <Button>{t("Contact")}</Button>
            </Span>
          </CustomNavLinkSmall>
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
